var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Meldung_Hinweis-flaechig") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.74%",
    y1: "0.03%",
    x2: "48.26%",
    y2: "99.97%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0270618%",
    y1: "-0.0229274796%",
    x2: "50.0270618%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE580",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE580",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA49",
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD321",
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE09",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    offset: "50%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0615352%",
    y1: "3.72623169e-05%",
    x2: "50.0615352%",
    y2: "99.9377424%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE580",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE580",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA49",
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD321",
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE09",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    offset: "50%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01---01-Fehlerscreen-Referenznummer",
    transform: "translate(-860.000000, -285.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meldung_Hinweis-flaechig",
    transform: "translate(860.000000, 285.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,8 C150.810197,8 192,49.189803 192,100 C192,150.810197 150.810197,192 100,192 C49.189803,192 8,150.810197 8,100 C8.06610916,49.2172115 49.2172115,8.06610916 100,8 M100,0 C44.771525,0 -1.42108547e-14,44.771525 -1.42108547e-14,100 C-1.42108547e-14,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 C200,73.478351 189.464316,48.0429597 170.710678,29.2893219 C151.95704,10.535684 126.521649,0 100,0 Z",
    id: "Shape",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,32.2 C83.218249,31.6240121 83.4319659,31.0639976 83.8319249,30.6489458 C84.2318839,30.233894 84.7836017,29.999869 85.36,29.999869 L114.5,29.999869 C115.081848,29.9935054 115.640308,30.2287217 116.042175,30.6495447 C116.444042,31.0703678 116.653287,31.6390688 116.62,32.22 L112.76,114.44 C112.686862,115.673138 111.675163,116.64123 110.44,116.66 L89.44,116.66 C88.2008368,116.651037 87.1835161,115.677567 87.12,114.44 L83.24,32.2 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,120.66 L89.44,120.66 C86.0828066,120.634381 83.3198663,118.011337 83.12,114.66 L79.26,32.38 C79.1689518,30.7115045 79.7778148,29.0806217 80.94,27.88 C82.096925,26.6791431 83.6925072,26 85.36,26 L114.5,26 C116.169227,26.0095708 117.763104,26.6961622 118.916759,27.9025991 C120.070414,29.1090359 120.685063,30.732014 120.62,32.4 L116.74,114.62 C116.540685,117.96372 113.789461,120.583933 110.44,120.62 L110.44,120.66 Z M91.04,112.66 L108.84,112.66 L112.52,34 L87.34,34 L91.04,112.68 L91.04,112.66 Z",
    id: "Shape",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.760012,153.6 C116.760012,160.251178 112.75235,166.24706 106.606688,168.790484 C100.461025,171.333907 93.3883212,169.923701 88.6880913,165.217746 C83.9878614,160.511791 82.5862658,153.437376 85.1371682,147.294814 C87.6880707,141.152252 93.6888266,137.151909 100.34,137.159988 C104.698322,137.159988 108.877847,138.892701 111.95777,141.976376 C115.037693,145.06005 116.765309,149.241681 116.760012,153.6 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.34,174.00001 C92.0673397,174.008079 84.6055162,169.028828 81.4378452,161.386653 C78.2701742,153.744479 80.0213374,144.946458 85.8738597,139.099667 C91.7263821,133.252877 100.526115,131.510336 108.165182,134.685494 C115.804249,137.860652 120.776185,145.327352 120.760039,153.6 C120.726999,164.860714 111.600741,173.978033 100.34,174.00001 Z M100.34,141.139984 C95.3066776,141.131908 90.7644676,144.157681 88.8326888,148.805544 C86.9009099,153.453407 87.9602812,158.807349 91.5165177,162.369313 C95.0727543,165.931276 100.424986,166.99926 105.075951,165.074962 C109.726916,163.150665 112.76,158.613329 112.76,153.58 C112.749027,146.721929 107.198044,141.162008 100.34,141.139984 L100.34,141.139984 Z",
    id: "Shape",
    fill: "#333333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.2517be521f32dccd84cac86054eaf51f.svg";
export { ForwardRef as ReactComponent };